import {createView, view} from '@sail/ui';

export const TopBar = createView((props) => {
  return (
    <view.div
      {...props}
      css={{
        minHeight: 'space.500',
        paddingX: 'medium',
        paddingY: 'small',
        border: '1px solid',
        borderColor: 'border',
        backgroundColor: 'surface',
        borderTopWidth: '0',
        borderLeftWidth: '0',
        borderRightWidth: '0',
        boxShadow: 'medium',
      }}
    />
  );
});
